const mutations = {
  SET_PAGE_SIZE(state, { pageSize }) {
    state.pageSize = pageSize;
    state.currentPage = 0;
  },

  SET_COLUMNS: (state, columns) => {
    state.columns = columns;
  },

  SET_CURRENT_PAGE(state, currentPage) {
    state.currentPage = currentPage;
  },

  SET_ORDERING(state, ordering) {
    state.ordering = ordering;
    state.currentPage = 0;
  },

  SET_COUNT(state, count) {
    state.count = count;
  },

  SET_SESSION_REPORT(state, report) {
    state.sessions = report;
  },

  SET_SEARCH_QUERY(state, query) {
    state.filters = {
      ...state.filters,
      query,
    };
  },

  SET_DATE_RANGE(state, dateRange) {
    state.dateRange = dateRange;
  },
};

export default mutations;
